import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import { parseCookies } from 'nookies'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiPatch = async (query, body, retryCount = 0) => {
  const { accessToken } = parseCookies()

  const config = {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: accessToken,
      ...config.headers,
    }
  }

  const response = await fetch(`${baseUrl}/admin/${query}`, config)
  const responseData = await response.json()

  if (response.status === 403 && retryCount === 0) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiPatch(query, body, retryCount + 1)
    } else {
      notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
      return responseData
    }
  }

  if (!responseData.success) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

/** PATCH with multipart body (e.g. FormData). Do not set Content-Type — the boundary is set automatically. */
export async function apiPatchFormData(query, formData, retryCount = 0) {
  const { accessToken } = parseCookies()

  const config = {
    method: 'PATCH',
    body: formData,
    headers: {
      Accept: 'application/json',
    },
  }

  if (!isEmpty(accessToken)) {
    config.headers.Authorization = accessToken
  }

  const response = await fetch(`${baseUrl}/admin/${query}`, config)
  const responseData = await response.json()

  if (response.status === 403 && retryCount === 0) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiPatchFormData(query, formData, retryCount + 1)
    }
    notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
    return responseData
  }

  if (!responseData.success) {
    notify.error(responseData.message, null, responseData.err)
  }
  return responseData
}

export default apiPatch

export const crmApiUpdateLead = (leadId, payload) => apiPatch(`crm/leads/${leadId}`, payload)
export const crmApiAssignLead = (leadId, payload) => apiPatch(`crm/leads/${leadId}/assign`, payload)
export const crmApiUpdateLeadStage = (leadId, payload) => apiPatch(`crm/leads/${leadId}/stage`, payload)
